import { camlizeKeys } from "@/features/common/helper";

const { API_ROOT } = runConfig;
const defaultErrorHandler = (error: any) => console.log("Error:", error);

interface RequestConfig {
  uri: string;
  body?: any;
  camelize?: boolean;
  method?: string;
}
export function sendRequest(
  { uri, camelize }: RequestConfig,
  applyResult: any,
  onError: (error: any) => void = defaultErrorHandler
) {
  fetch(`${API_ROOT}${uri}`, {
    method: "GET",
    mode: "cors",
    credentials: "include"
  })
    .then((res) => {
      if (!res.ok) {
        const error: any = new Error(`Error in API: ${res.url}, Status: ${res.status}`);
        error.status = res.status;
        throw error;
      }
      res.json().then((result) => {
        if (camelize) {
          result = camlizeKeys(result);
        }

        applyResult(result);
      });
    })
    .catch(onError);
}

export function sendRequestWithPayload(
  { uri, body, camelize, method = "POST" }: RequestConfig,
  applyResult: any,
  onError: any = defaultErrorHandler
) {
  fetch(`${API_ROOT}${uri}`, {
    method: method,
    mode: "cors",
    credentials: "include",
    body: body
  })
    .then((res) =>
      res.json().then((result) => {
        if (camelize) {
          result = camlizeKeys(result);
        }
        applyResult(result);
      })
    )
    .catch(onError);
}
